<template>
  <div v-if="bootstrapSucceed" :class="webViewClass + ' n-lang-' + curLang">
    <TheHeader :menus="menus" />
    <NViewContainer :from-web-view="fromWebView">
      <RouterView />
    </NViewContainer>
    <TheFooter />
  </div>
</template>

<script setup>
import {onUnmounted, ref} from 'vue';
import {bootstrap} from '@front/api/utility';
import menus from '../../menus';
import {useBootstrap, useCompetition, useLanguage, useRouter, useWebView} from '@front/hooks';
import {storage} from '@/services';
import {VERIFY_HINTING_CLOSE_COUNT_STORAGE_KEY} from '@front/config';
import {mySentry} from '@/monitor';
import {NavigatorMessage, NoAuthMessage} from '@/models';
import {DEFAULT_GUEST_PORTAL} from "@/glue";

const { fromWebView, webViewClass, setWebView } = useWebView();
const { setCompetition } = useCompetition();

const { router, routerTo } = useRouter();
const query = router.currentRoute.value.query;
const bootstrapSucceed = ref(false);
const { isGuest } = useBootstrap();
const { curLang , changeLanguage} = useLanguage();

const wv = query.wv === 'true';
const lang = query.lang ?? curLang.value;
const webViewData = { from: wv, className: wv ? 'n-webview-container' : '' };
// ignore query.currency=USD  for now
const competitionData = { payPurpose: query.payPurpose , payAmount: query.payAmount , relatedId: query.competitionId};

try {
  await bootstrap();
  bootstrapSucceed.value = true;
  
  if(isGuest.value ?? false) {
    routerTo(DEFAULT_GUEST_PORTAL);
  }
} catch (err) {
  if (err instanceof NoAuthMessage) {
    throw new NavigatorMessage({ path: '/login', type: 'replace' });
  } else {
    throw err;
  }
}

const { verified } = useBootstrap();
setWebView(webViewData);
setCompetition(competitionData);
changeLanguage(lang);

if (verified.value) {
  // 过期了后, 还要以重复之前的逻辑
  storage.remove(VERIFY_HINTING_CLOSE_COUNT_STORAGE_KEY);
}

onUnmounted(() => {
  mySentry?.setUser({});
});
</script>
